<template>
  <v-app>
    <Appbar/>
    <v-main>
      <Information/>

      <div class="d-flex" style="margin-top: 20px; margin-left: 40px">
        <div class="kaisei tab selected" tile>執筆記録</div>
        <div class="kaisei tab notselected" tile style="margin-left: 10px">執筆カレンダー</div>
      </div>
      <div style="background-color: var(--v-secondary-base);height:5px;width: 100%"/>

      <div class="d-flex" style="background-color: var(--v-diaryBackground-base);width: 100%;height: 100%;">
        <div class="diary-view-main">
          <NovelDiaryCalendarTopFukidashi/>
        </div>
        <div class="diary-right">
          bb
        </div>
      </div>

    </v-main>
    <Footer
        :accent-color="accentColor"
        :sub-primary-color="subPrimaryColor"
    />
  </v-app>

</template>

<script>
import Information from '../component/Information.vue';
import Footer from '../component/Footer.vue';
import Appbar from "@/component/Appbar.vue";
import {mapState} from "vuex";
import NovelDiaryCalendarTopFukidashi from "@/component/svg/NovelDiaryCalendarTopFukidashi.vue";

export default {
  name: "NovelDiary",
  components: {
    NovelDiaryCalendarTopFukidashi,
    Appbar,
    Footer,
    Information,
  },
  data() {
    return {
      accentColor: null,
      subPrimaryColor: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
    })
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    const primary = this.$vuetify.theme.themes.light.primary
    const red = parseInt(primary.substring(1, 3), 16);
    const green = parseInt(primary.substring(3, 5), 16);
    const blue = parseInt(primary.substring(5, 7), 16);
    this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
  },
}
</script>

<style scoped>
.diary-right {
  width: 400px;
  max-width: 400px;
  background-color: var(--v-diaryBackground-base);
}

.diary-view-main {

  width: 100%;
}
</style>